export const URLS = {
  // admin
  AUTH_ADMIN_DEPOSITS: '/shop-reception/admin/deposits',
  AUTH_ADMIN_HUBS: '/shop-reception/admin/hubs',
  AUTH_ADMIN_HUBS_DELIVERY_INTERVAL: '/shop-reception/admin/hubs/deliveryInterval/:id',
  AUTH_ADMIN_STORES: '/shop-reception/admin/stores',
  AUTH_ADMIN_REGIONS: '/shop-reception/admin/regions',
  AUTH_CENTRALIZATION_STORES_HUB: '/shop-reception/admin/centralization',
  AUTH_MANAGE_SCAN_TYPES: '/shop-reception/admin/scanTypes',
  AUTH_SUBFAMILY_VALIDITY_THRESHOLD: '/shop-reception/admin/subfamilyValidityTreshold',
  AUTH_METI_PRODUCTS: '/shop-reception/admin/metiProducts',
  AUTH_ADMIN_SENSITIVE_PRODUCTS: '/shop-reception/admin/sensitiveProducts',
  AUTH_ADMIN_PACKING_TYPES: '/shop-reception/admin/packingTypes',
  AUTH_MANAGE_DLC_PRODUCTS: '/shop-reception/admin/shortDlcProducts',
  AUTH_RECEPTION_FILES_INFO: '/shop-reception/admin/receptionFiles',
  AUTH_SGR_PRODUCTS: '/shop-reception/admin/sgrProducts',
  AUTH_PARENT_SOCIETY_LIST: '/shop-reception/admin/parentSocietyList',
  AUTH_NOTICE_SERIES_NUMBER_LIST: '/shop-reception/admin/noticeSeriesNumberList',

  // reception dashboard
  AUTH_DELIVERY_SLIPS_LIST: '/shop-reception/reception/deliveryTicket',
  AUTH_DELIVERY_SLIPS_SUPPORT_CODE: '/shop-reception/reception/deliverySupportAction/:id',
  AUTH_DELIVERY_SLIP: '/shop-reception/reception/deliveryTicket/:id',
  AUTH_TRUCK_LIST: '/shop-reception/reception/truckList',
  AUTH_TRUCK_DETAIL: '/shop-reception/reception/truckList/:id',
  AUTH_SUPPORT_WRONG_DESTINATION: '/shop-reception/reception/wrongDestinationSupport',
  AUTH_SUPPORT_WRONG_DESTINATION_DETAIL: '/shop-reception/reception/wrongDestinationSupport/:id',
  AUTH_UNORDERED_PRODUCTS: '/shop-reception/reception/nonRecommendedProducts',
  AUTH_METI_FILES: '/shop-reception/reception/metiFiles',
  AUTH_METI_FILE_DETAIL: '/shop-reception/reception/metiFiles/:id',
  AUTH_DIFFERENCES_PRODUCTS: '/shop-reception/reception/productsDifferences',
  AUTH_SUPPORT_TRACEABILITY: '/shop-reception/reception/traceabilitySupport',
  AUTH_GOODS_DELIVERY_REPORT: '/shop-reception/reception/goodsDeliveryReport',
  AUTH_SENSITIVE_PRODUCTS: '/shop-reception/reception/sensitiveProducts',
  AUTH_DELIVERY_TRUCK_LIST: '/shop-reception/reception/deliveryTruckList',

  // package
  AUTH_RETURN_TRUCK_LIST: '/shop-reception/package/trucksReturn',
  AUTH_RETURN_TRUCK_DETAILS: '/shop-reception/package/trucksReturn/:id',
  AUTH_ROLLING_PACKAGES: '/shop-reception/package/rolling',
  AUTH_BALANCE_PACKAGING: '/shop-reception/package/balance',
  AUTH_BALANCE_PACKAGING_HISTORY: '/shop-reception/package/balance/history/:id',
  AUTH_PACKAGING_DISPUTES_OF_STORE_RETURNS: '/shop-reception/package/storeReturnsDisputes',
  AUTH_PACKAGING_DISPUTE_OF_STORE_RETURNS: '/shop-reception/package/storeReturnsDisputes/:id',
  AUTH_PACKAGING_DISPUTE_OF_STORE_RETURNS_IMAGES:
    '/shop-reception/package/storeReturnsDisputesImages/:id',
  AUTH_PACKAGING_TYPES_DIFFERENCES: '/shop-reception/package/typesDifferences',
  AUTH_RETURNED_PACKAGING: '/shop-reception/package/returned',
  AUTH_PACKAGING_COMPLIANCE: '/shop-reception/package/compliance',
  AUTH_PACKAGING_DISPUTES_OF_TIMER_ADMINISTRATION: '/shop-reception/package/timerDisputes',
  AUTH_PACKAGING_CENTRALIZED_NOTICE: '/shop-reception/package/centralizedNotice',
  AUTH_PACKING_INVENTORY: '/shop-reception/package/packingInventory',
  AUTH_PACKING_INVENTORY_HISTORY: '/shop-reception/package/packingInventoryHistory/:id',
  AUTH_TRANSPORT_RESPONSIBLE: '/shop-reception/package/transportResponsible',

  // historical reports
  AUTH_DELIVERY_SLIPS_LIST_HISTORICAL: '/shop-reception/reception/history/deliveryTicket',
  AUTH_DELIVERY_SLIP_HISTORICAL: '/shop-reception/reception/history/deliveryTicket/:id',
  AUTH_TRUCK_LIST_HISTORICAL: '/shop-reception/reception/history/truckList',
  AUTH_TRUCK_DETAIL_HISTORICAL: '/shop-reception/reception/history/truckList/:id',
  AUTH_SUPPORT_WRONG_DESTINATION_HISTORICAL:
    '/shop-reception/reception/history/wrongDestinationSupport',
  AUTH_SUPPORT_WRONG_DESTINATION_DETAIL_HISTORICAL:
    '/shop-reception/reception/history/wrongDestinationSupport/:id',
  AUTH_UNORDERED_PRODUCTS_HISTORICAL: '/shop-reception/reception/history/nonRecommendedProducts',
  AUTH_METI_FILES_HISTORIAL: '/shop-reception/reception/history/metiFiles',
  AUTH_METI_FILE_DETAIL_HISTORICAL: '/shop-reception/reception/history/metiFiles/:id',
  AUTH_DIFFERENCES_PRODUCTS_HISTORICAL: '/shop-reception/reception/history/productsDifferences',

  // Shop Returo
  AUTH_RETURO_REPORTS: '/shop-reception/returo/reports',
  AUTH_RETURO_IN_PROGRESS_SEALS: '/shop-reception/returo/inProgressSeals',

  // Direct Suppliers
  AUTH_ADMIN_SUPPLIERS_PACKAGING_TYPES: '/shop-reception/suppliers/admin/packingTypes',
  AUTH_ADMIN_SUPPLIERS_DLC_PRODUCTS: '/shop-reception/suppliers/admin/shortDlcProducts',
  AUTH_SUPPLIERS_ORDER_LIST: '/shop-reception/suppliers/admin/orders',
  AUTH_SUPPLIERS_ORDER: '/shop-reception/suppliers/admin/orders/:id',
  AUTH_SUPPLIERS_ORDER_LIST_HISTORICAL: '/shop-reception/suppliers/reception/history/orders',
  AUTH_SUPPLIERS_ORDER_HISTORICAL: '/shop-reception/suppliers/reception/history/orders/:id',
  AUTH_SUPPLIERS_METI_RESPONSE: '/shop-reception/suppliers/reception/metiFiles',
  AUTH_SUPPLIERS_METI_RESPONSE_HISTORICAL: '/shop-reception/suppliers/reception/history/metiFiles',
  AUTH_SUPPLIERS_PRODUCTS_WITH_DIFFERENCES: '/shop-reception/suppliers/reception/productsDifferences',
  AUTH_SUPPLIERS_PRODUCTS_WITH_DIFFERENCES_HISTORY: '/shop-reception/suppliers/reception/history/productsDifferences',
  AUTH_SUPPLIERS_RETURN_TRUCK_LIST: '/shop-reception/suppliers/package/trucksReturn',
  AUTH_SUPPLIERS_RETURN_TRUCK_DETAILS: '/shop-reception/suppliers/package/trucksReturn/:id',
  AUTH_SUPPLIERS_BALANCE_PACKAGING: '/shop-reception/suppliers/package/balance',
  AUTH_SUPPLIERS_BALANCE_PACKAGING_HISTORY: '/shop-reception/suppliers/package/balance/history/:id',
}

export const SCREENS = {
  ADMIN_SHOP: 'ADMIN_SHOP',
  ADMIN_DELIVERY_MATRIX: 'ADMIN_DELIVERY_MATRIX',
  ADMIN_SCAN_TYPE: 'ADMIN_SCAN_TYPE',
  ADMIN_SENSITIVE: 'ADMIN_SENSITIVE',
  ADMIN_SUPPORT_TYPE: 'ADMIN_SUPPORT_TYPE',
  ADMIN_DLC: 'ADMIN_DLC',
  ADMIN_IMPORT_ALL_SHOP_TYPES: 'ADMIN_IMPORT_ALL_SHOP_TYPES',
  ADMIN_INFOLOG: 'ADMIN_INFOLOG',
  ADMIN_SGR: 'ADMIN_SGR',
  ADMIN_DEPOSIT: 'ADMIN_DEPOSIT',
  ADMIN_PARENT_SOCIETY: 'ADMIN_PARENT_SOCIETY',
  PACKAGING_RETURN_LITIGATION: 'PACKAGING_RETURN_LITIGATION',
  PACKAGING_SUPPORT_STOCK_INVENTORY: 'PACKAGING_SUPPORT_STOCK_INVENTORY',
  PACKAGING_SUPPORT_STOCK: 'PACKAGING_SUPPORT_STOCK',
  PACKAGING_RETURN_TRUCK: 'PACKAGING_RETURN_TRUCK',
  RECEPTION_METI: 'RECEPTION_METI',
  RETURO_NOTICE: 'RETURO_NOTICE'
}
